<template>
  <div>
    <div style="text-align: center" class="search-btn">
      <el-button icon="el-icon-search" size="mini" @click="changeShowStatus" circle></el-button>
    </div>
    <div class="header" ref="header">
      &nbsp;
      &nbsp;
      <!-- <span class="selected_lable">科室：</span>
      <el-select v-model="department" @change="searchConditionChange(true)" placeholder="请选择" class="selected" size="small">
        <el-option
          v-for="item in options_02"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select> -->
      &nbsp;
      &nbsp;
      <span class="selected_lable">部位：</span>
      <el-select v-model="preset" @change="searchConditionChange(true)" placeholder="请选择" class="selected" size="small">
        <el-option
          v-for="item in options_03"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      &nbsp;
      &nbsp;
      <span class="selected_lable">质控：</span>
      <el-select v-model="qcStatus" multiple @change="searchConditionChange(true)" placeholder="请选择" class="selected" size="small">
        <el-option
          v-for="item in options_04"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      &nbsp;
      &nbsp;
      <span class="selected_lable">日期：</span>
      <el-date-picker
        v-model="durationStart"
        align="right"
        type="date"
        placeholder="选择日期"
        @change="searchConditionChange(true)"
        :clearable="isClear"
        class="time-select">
      </el-date-picker>
      <el-date-picker
        v-model="durationEnd"
        align="right"
        type="date"
        placeholder="选择日期"
        @change="searchConditionChange(true)"
        :clearable="isClear"
        class="time-select">
      </el-date-picker>

      <i class="el-icon-refresh-left" ref="refresh" @click="searchConditionChange(false)"></i>

      <el-input
        class="search"
        placeholder="搜索"
        suffix-icon="el-icon-search"
        v-model="inputSearch"
        size="small"
        clearable
        @change="searchConditionChange(true)"
        @input="searchConditionChange(true)"
      >
      </el-input>
    </div>
  </div>
</template>

<script>
import {getDepartmentList, getPresetList} from '../../../request/api'

export default {
  name: 'SearchCondition',
  props: {
    orderTab: Number
  },
  data () {
    return {
      // 订单类型
      options_01: [
        {
          value: 0,
          label: '全部'
        },
        {
          value: 1,
          label: '同步'
        },
        {
          value: 2,
          label: '异步'
        }
      ],
      // 科室选择
      options_02: [
        {
          value: 0,
          label: '全部'
        }
      ],
      // 部位选择
      options_03: [
        {
          value: 20,
          label: '全部'
        }
      ],
      // 质控状态选择
      options_04: [
        {
          value: -1,
          label: '待质控'
        },
        {
          value: 0,
          label: '正常'
        },
        {
          value: 1,
          label: '质控一级'
        },
        {
          value: 2,
          label: '质控二级'
        },
        {
          value: 3,
          label: '质控三级'
        }
      ],
      isClear: false
    }
  },
  mounted () {
    this.getDepartment()
    this.getPreset()
  },
  computed: {
    department: {
      get () {
        if (this.orderTab === 0) {
          return this.$store.state.searchCondition.getOrder.department
        }
        if (this.orderTab === 1) {
          return this.$store.state.searchCondition.magOrder.department
        }
        if (this.orderTab === 2) {
          return this.$store.state.searchCondition.reportOrder.department
        }
        if (this.orderTab === 3) {
          return this.$store.state.searchCondition.allOrder.department
        }
        if (this.orderTab === 4) {
          return this.$store.state.searchCondition.payOrder.department
        }
        if (this.orderTab === 5) {
          return this.$store.state.searchCondition.refundOrder.department
        }
        if (this.orderTab === 6) {
          return this.$store.state.searchCondition.classicalOrder.department
        }
      },
      set (val) {
        if (this.orderTab === 0) {
          this.$store.commit('changeDepartment', val)
        }
        if (this.orderTab === 1) {
          this.$store.commit('changeMagDepartment', val)
        }
        if (this.orderTab === 2) {
          this.$store.commit('changeReportDepartment', val)
        }
        if (this.orderTab === 3) {
          this.$store.commit('changeAllDepartment', val)
        }
        if (this.orderTab === 4) {
          this.$store.commit('changePayDepartment', val)
        }
        if (this.orderTab === 5) {
          this.$store.commit('changeRefundDepartment', val)
        }
        if (this.orderTab === 6) {
          this.$store.commit('changeClassicalDepartment', val)
        }
      }
    },
    preset: {
      get () {
        if (this.orderTab === 0) {
          return this.$store.state.searchCondition.getOrder.preset
        }
        if (this.orderTab === 1) {
          return this.$store.state.searchCondition.magOrder.preset
        }
        if (this.orderTab === 2) {
          return this.$store.state.searchCondition.reportOrder.preset
        }
        if (this.orderTab === 3) {
          return this.$store.state.searchCondition.allOrder.preset
        }
        if (this.orderTab === 4) {
          return this.$store.state.searchCondition.payOrder.preset
        }
        if (this.orderTab === 5) {
          return this.$store.state.searchCondition.refundOrder.preset
        }
        if (this.orderTab === 6) {
          return this.$store.state.searchCondition.classicalOrder.preset
        }
      },
      set (val) {
        if (this.orderTab === 0) {
          this.$store.commit('changePreset', val)
        }
        if (this.orderTab === 1) {
          this.$store.commit('changeMagPreset', val)
        }
        if (this.orderTab === 2) {
          this.$store.commit('changeReportPreset', val)
        }
        if (this.orderTab === 3) {
          this.$store.commit('changeAllPreset', val)
        }
        if (this.orderTab === 4) {
          this.$store.commit('changePayPreset', val)
        }
        if (this.orderTab === 5) {
          this.$store.commit('changeRefundPreset', val)
        }
        if (this.orderTab === 6) {
          this.$store.commit('changeClassicalPreset', val)
        }
      }
    },
    qcStatus: {
      get () {
        if (this.orderTab === 0) {
          return this.$store.state.searchCondition.getOrder.qcStatus
        }
        if (this.orderTab === 1) {
          return this.$store.state.searchCondition.magOrder.qcStatus
        }
        if (this.orderTab === 2) {
          return this.$store.state.searchCondition.reportOrder.qcStatus
        }
        if (this.orderTab === 3) {
          return this.$store.state.searchCondition.allOrder.qcStatus
        }
        if (this.orderTab === 4) {
          return this.$store.state.searchCondition.payOrder.qcStatus
        }
        if (this.orderTab === 5) {
          return this.$store.state.searchCondition.refundOrder.qcStatus
        }
        if (this.orderTab === 6) {
          return this.$store.state.searchCondition.classicalOrder.qcStatus
        }
      },
      set (val) {
        if (this.orderTab === 0) {
          this.$store.commit('changeQCStatus', val)
        }
        if (this.orderTab === 1) {
          this.$store.commit('changeMagQCStatus', val)
        }
        if (this.orderTab === 2) {
          this.$store.commit('changeReportQCStatus', val)
        }
        if (this.orderTab === 3) {
          this.$store.commit('changeAllQCStatus', val)
        }
        if (this.orderTab === 4) {
          this.$store.commit('changePayQCStatus', val)
        }
        if (this.orderTab === 5) {
          this.$store.commit('changeRefundQCStatus', val)
        }
        if (this.orderTab === 6) {
          this.$store.commit('changeClassicalQCStatus', val)
        }
      }
    },
    durationStart: {
      get () {
        if (this.orderTab === 0) {
          return this.$store.state.searchCondition.getOrder.durationStart
        }
        if (this.orderTab === 1) {
          return this.$store.state.searchCondition.magOrder.durationStart
        }
        if (this.orderTab === 2) {
          return this.$store.state.searchCondition.reportOrder.durationStart
        }
        if (this.orderTab === 3) {
          return this.$store.state.searchCondition.allOrder.durationStart
        }
        if (this.orderTab === 4) {
          return this.$store.state.searchCondition.payOrder.durationStart
        }
        if (this.orderTab === 5) {
          return this.$store.state.searchCondition.refundOrder.durationStart
        }
        if (this.orderTab === 6) {
          return this.$store.state.searchCondition.classicalOrder.durationStart
        }
      },
      set (val) {
        if (this.orderTab === 0) {
          this.$store.commit('changeDurationStart', val)
        }
        if (this.orderTab === 1) {
          this.$store.commit('changeMagDurationStart', val)
        }
        if (this.orderTab === 2) {
          this.$store.commit('changeReportDurationStart', val)
        }
        if (this.orderTab === 3) {
          this.$store.commit('changeAllDurationStart', val)
        }
        if (this.orderTab === 4) {
          this.$store.commit('changePayDurationStart', val)
        }
        if (this.orderTab === 5) {
          this.$store.commit('changeRefundDurationStart', val)
        }
        if (this.orderTab === 5) {
          this.$store.commit('changeClassicalDurationStart', val)
        }
      }
    },
    durationEnd: {
      get () {
        if (this.orderTab === 0) {
          return this.$store.state.searchCondition.getOrder.durationEnd
        }
        if (this.orderTab === 1) {
          return this.$store.state.searchCondition.magOrder.durationEnd
        }
        if (this.orderTab === 2) {
          return this.$store.state.searchCondition.reportOrder.durationEnd
        }
        if (this.orderTab === 3) {
          return this.$store.state.searchCondition.allOrder.durationEnd
        }
        if (this.orderTab === 4) {
          return this.$store.state.searchCondition.payOrder.durationEnd
        }
        if (this.orderTab === 5) {
          return this.$store.state.searchCondition.refundOrder.durationEnd
        }
        if (this.orderTab === 5) {
          return this.$store.state.searchCondition.classicalOrder.durationEnd
        }
      },
      set (val) {
        if (this.orderTab === 0) {
          this.$store.commit('changeDurationEnd', val)
        }
        if (this.orderTab === 1) {
          this.$store.commit('changeMagDurationEnd', val)
        }
        if (this.orderTab === 2) {
          this.$store.commit('changeReportDurationEnd', val)
        }
        if (this.orderTab === 3) {
          this.$store.commit('changeAllDurationEnd', val)
        }
        if (this.orderTab === 4) {
          this.$store.commit('changePayDurationEnd', val)
        }
        if (this.orderTab === 5) {
          this.$store.commit('changeRefundDurationEnd', val)
        }
        if (this.orderTab === 6) {
          this.$store.commit('changeClassicalDurationEnd', val)
        }
      }
    },
    inputSearch: {
      get () {
        if (this.orderTab === 0) {
          return this.$store.state.searchCondition.getOrder.inputSearch
        }
        if (this.orderTab === 1) {
          return this.$store.state.searchCondition.magOrder.inputSearch
        }
        if (this.orderTab === 2) {
          return this.$store.state.searchCondition.reportOrder.inputSearch
        }
        if (this.orderTab === 3) {
          return this.$store.state.searchCondition.allOrder.inputSearch
        }
        if (this.orderTab === 4) {
          return this.$store.state.searchCondition.payOrder.inputSearch
        }
        if (this.orderTab === 5) {
          return this.$store.state.searchCondition.refundOrder.inputSearch
        }
        if (this.orderTab === 6) {
          return this.$store.state.searchCondition.classicalOrder.inputSearch
        }
      },
      set (val) {
        if (this.orderTab === 0) {
          this.$store.commit('changeInputSearch', val)
        }
        if (this.orderTab === 1) {
          this.$store.commit('changeMagInputSearch', val)
        }
        if (this.orderTab === 2) {
          this.$store.commit('changeReportInputSearch', val)
        }
        if (this.orderTab === 3) {
          this.$store.commit('changeAllInputSearch', val)
        }
        if (this.orderTab === 4) {
          this.$store.commit('changePayInputSearch', val)
        }
        if (this.orderTab === 5) {
          this.$store.commit('changeRefundInputSearch', val)
        }
        if (this.orderTab === 6) {
          this.$store.commit('changeClassicalInputSearch', val)
        }
      }
    }
  },
  methods: {
    changeShowStatus () {
      if (this.$refs.header.style.display === 'flex') {
        this.$refs.header.style.display = 'none'
      } else {
        this.$refs.header.style.display = 'flex'
      }
    },
    searchConditionChange (isBackToOne) {
      this.$emit('searchConditionChange', {isBackToOne})
    },
    getDepartment () {
      let that = this
      getDepartmentList().then(resp => {
        if (resp.code === 1000) {
          let departmentList = resp.data
          for (let department of departmentList) {
            let option02 = {value: department.id, label: department.name}
            that.options_02.push(option02)
          }
        } else {
          that.$message.error('请求数据失败')
        }
      })
    },
    getPreset () {
      let that = this
      // 请求部位数据
      getPresetList().then(function (response) {
        if (response.code === 1000) {
          let presetList = response.data
          for (let preset of presetList) {
            let option03 = {value: preset.preset_id, label: preset.preset_name}
            that.options_03.push(option03)
          }
        } else {
          that.$message.error('请求数据失败')
        }
      })
    }
  }
}
</script>

<style scoped>
.header {
  position: relative;
  display: flex;
  align-items: center;
}
@media (max-width: 900px) {
  .header {
    display: none;
    flex-direction: column;
  }
}
.selected_lable {
  flex: 0.4;
  font-size: 10pt;
  color: #8DA1C5;
  text-align: center;
}
.selected {
  flex: 1;
}
/deep/ .el-input--suffix .el-input__inner::placeholder { font-size: 13px; }
@media (max-width: 900px) {
  .selected {
    width: 50%;
  }
}
.search {
  width: 11%;
  flex: 1;
}
@media (max-width: 900px) {
  .search {
    width: 50%;
  }
}
.el-icon-refresh-left {
  font-size: 1.5rem;
  text-align: center;
  flex: 1;
  cursor: pointer;
  transition: 0.2s;
}
.el-icon-refresh-left:hover {
  font-size: 1.7rem;
}
.el-icon-refresh-left:active {
  -moz-transform:rotate(-180deg);
  -webkit-transform:rotate(-180deg);
}
.time-select {
  flex: 1.5;
  width: 12%;
}
@media (max-width: 900px) {
  .time-select {
    width: 50%;
  }
}
.search-btn {
  display: none;
}
@media (max-width: 900px) {
  .search-btn {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/order/SearchCondition.vue